import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge, Button } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class DataTableMatchingDemandSupply extends Component {

    render() {
        
        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange, onLoadDetail } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, Masterbase, DetailMap } = props;
        console.log("DetailMap", DetailMap);
        

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.status !== '2') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
                    
                    <Row>
                        <Col md={12}>
                            {DataTable?.rows?.length > 0 ? 
                                <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance table-responsive ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                    >
                                    <thead>
                                        <tr>
                                            <th className="th-width-75p th-font-sm">ปี</th>
                                            <th className="th-width-175p th-font-sm">สถานประกอบการ</th>
                                            <th className="th-width-175p th-font-sm">อุตสาหกรรม</th>
                                            <th className="th-width-150p th-font-sm">ตำแหน่งงาน</th>
                                            <th className="th-width-250p th-font-sm">สถานศึกษา</th>
                                            <th className="th-width-175p th-font-sm">ระดับการศึกษา</th>
                                            <th className="th-td-align-center th-width-125p th-font-sm">จำนวนทักษะที่ต้องการ</th>
                                            <th className="th-td-align-center th-width-125p th-font-sm">ทักษะที่ตรงกัน</th>
                                            <th className="th-td-align-center th-width-125p th-font-sm">Skill Gaps</th>
                                            {/* <th className="th-width-200p th-font-sm">ทักษะที่ต้องการ</th>
                                            <th className="th-width-200p th-font-sm">ทักษะเทียบเคียง</th> */}
                                            <th className="th-td-align-center th-width-100p th-font-sm">Matching</th>
                                            <th className="th-td-align-center th-width-150p th-font-sm">ความต้องการกำลังคน</th>
                                            <th className="th-td-align-center th-width-125p th-font-sm">ผลผลิตกำลังคน</th>
                                        </tr>                                        
                                    </thead>
                                    <tbody>
                                        {DataTable.rows.map((row, index) => {
                                            const detailKey = `${row.manpower_establishments_id}_${row.academy_name}`;
                                            const details = props.DetailMap?.[detailKey] || [];

                                            Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                            
                                            rowId++;

                                            let del = true;
                                            if (['0', '1'].includes(row.status)) { del = false; }

                                            return (
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="text-truncate td-font-sm" >{row.years}</td>
                                                            <td className="text-truncate td-font-sm" title={row.enterprise_operator_name}>{row.enterprise_operator_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.target_industries_name}>{row.target_industries_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.position_name}>{row.position_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.academy_name}>{row.academy_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.demand_edu_level_name}>{row.demand_edu_level_name}</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center" >{row.total_demand_skills}</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center" >{row.matched_skills}</td>
                                                           <td className="td-font-sm">
                                                                {details.length > 0 ? (
                                                                    details.map((d, i) => (
                                                                    <Badge
                                                                        key={i}
                                                                        bg={d.matched_flag ? 'success' : 'danger'}
                                                                        className="me-1 mb-1"
                                                                    >
                                                                        {d.demand_skill_name}
                                                                    </Badge>
                                                                    ))
                                                                ) : (
                                                                    <span className="text-muted">กำลังโหลด…</span>
                                                                )}
                                                            </td>
                                                            {/* <td className="text-truncate td-font-sm" >{row.demand_skill_name}</td>
                                                            <td className="text-truncate td-font-sm" >{row.supply_skill_name}</td> */}
                                                            <td className="text-truncate td-font-sm th-td-align-center" >{row.matching_rate_percent} %</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center" >{row.total_demand_positions}</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center" >{row.total_matched_supply_release_amount}</td>


                                                            {/* <td className="text-truncate td-font-sm" title={row.position_name}>{row.position_name}</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center"> 
                                                                <CommonButton 
                                                                    task="open-content"
                                                                    rounded={true}
                                                                    disabled={false}
                                                                    inlineClass='btn-font-sm text-secondary'
                                                                    callback={() => Actions.handlePrintEBPopup('eb01-print',row.id)} 
                                                                />                                                                                                                                                                                        
                                                            </td>  */}
                                                            {/* <td className="th-td-align-center">
                                                               <CommonDropdown
                                                                    element="DataTable"
                                                                    input={{id: 'operation', value: row.operation}}
                                                                    option={{source: 'options', section: 'status', item: 'eb01_course_operation_status'}}
                                                                    size="sm"
                                                                    callback={async (e, element) => { 
                                                                        if (['1'].includes(e.target.value)){
                                                                            await onSetEdit(e, {id: row.id}, true);
                                                                        }else{                                                                        
                                                                            onDropDownChange(e, element, {key: 'id', value: row.id});
                                                                        }
                                                                    }}
                                                                    disabled={['0', '1'].includes(row.status)}
                                                                />                                                                 
                                                            </td> */}                                                        
                                                        </tr>
                                                    </React.Fragment>       
                                              )
                                        })}
                                    </tbody>                                                                                  
                                </Table>    
                            :
                                <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                            }

                            {!Action.Loading.dataTable && (
                                <CommonPagination 
                                    Pagination={DataTable.pagination} 

                                    handlePagination={(paging) => onPaginationChange(paging)}
                                />
                            )}                 
                        </Col>
                    </Row>

            </Container>
        );                
    }
}

export default DataTableMatchingDemandSupply;
